import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

type LanguageText = {
  type: string;
  description: string;
};

type Notification = {
  _id: string;
  active: boolean;
  notificationType: string;
  notificationDate: string;
  languageTexts: LanguageText[];
  createdAt: string;
  updatedAt: string;
  timeZoneByNotification: any[];
};

type Params = {
  subscription: string;
};

const fetchGlobalAlert = async (params: Params): Promise<Notification[]> => {
  const { data } = await apiInputService.get<Notification[]>(
    `/generalNotification/findActiveGeneralNotification`
  );
  return data;
};

export const useGetGlobalAlert = (params: Params, options?: any) => {
  return useQuery(["globalAlert"], () => fetchGlobalAlert(params), {
    ...options,
    enabled: !!params.subscription,
  });
};
